'use strict';

(() => {
  // =========================
  // 	DOM
  const DOM = {};
  DOM.btnHeaderSearch = document.querySelector('button.btn-header-search');
  DOM.headerSearch = document.querySelector('input.header-search');

  // =========================
  // 	VARS

  // =========================
  // 	INIT
  const init = () => {
    DOM.headerSearch?.addEventListener('input', handleHeaderSearch);
  };

  // =========================
  // 	FUNCTIONS
  const handleHeaderSearch = (e) => {
    if (DOM.headerSearch.value.trim() === '') {
      DOM.btnHeaderSearch.disabled = true;
    } else {
      DOM.btnHeaderSearch.disabled = false;
    }
  };

  init();
})();
